import React from 'react'
import { Icon } from 'antd'
import { SyncOutlined } from '@ant-design/icons'

import './StepTitle.scss'

function StepTitle({
  iconType = '',
  title = '',
  description = '',
  contentExtra = null,
  showDivider = true,
  isLoading = false,
  progress = {},
  isGeneratingLocationReference = false,
  extra = null
}) {
  const stepTitleClass = `video-generation__step-title${
    showDivider ? '' : ' video-generation__step-title--no-divider'
  }`

  return (
    <div className={stepTitleClass}>
      <div className="video-generation__step-title__icon">
        <Icon type={iconType} />
      </div>

      <div className="video-generation__step-title__content">
        <div className="video-generation__step-title__title-row">
          <h1>{title}</h1>
          {contentExtra && (
            <div className="video-generation__step-title__content-extra">
              {contentExtra}
            </div>
          )}
        </div>
        <p>{description}</p>
      </div>

      {extra && <div className="video-generation__step-title__extra">{extra}</div>}

      {isLoading && (
        <div className="video-generation__step-title__loading">
          <SyncOutlined spin />

          <span>
            Generation in progress...({progress.current}/{progress.total}{' '}
            completed)
          </span>
        </div>
      )}

      {isGeneratingLocationReference && (
        <div className="video-generation__step-title__loading">
          <SyncOutlined spin />

          <span>Generating location images...</span>
        </div>
      )}
    </div>
  )
}

export default StepTitle
